import React from 'react';

const SvgArrowRight = props => (
  <svg width={6} height={9} {...props}>
    <path
      d="M1.695.695l3.31 3.31a.7.7 0 0 1 0 .99l-3.31 3.31A.7.7 0 0 1 .5 7.81V1.19A.7.7 0 0 1 1.695.695z"
      fill="#046FE2"
      fillRule="nonzero"
    />
  </svg>
);

export default SvgArrowRight;
